import React from 'react';
import PropTypes from 'prop-types';
import ConfigureProductsIcon from '../../../icons/icon-configure-products.svg';


const ServiceCallout = ({ addOn }) => (
  <div className="service-callout">
    <ConfigureProductsIcon className="service-callout__icon" />
    <div className="service-callout__text">{addOn.content.title}</div>
  </div>
);

ServiceCallout.propTypes = {
  addOn: PropTypes.shape({
    content: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ServiceCallout;
